const __DEV__ = window.gon.reactAppEnv === "development"

/**
 * Utility to log a warning message in development mode
 * @param condition - condition to check
 * @param message - message to log when condition is `true`
 * @returns void
 */
export function devWarning(condition: boolean, message: string, ...optionalParams: unknown[]) {
  if (!__DEV__) return

  if (condition) {
    console.warn(message, ...optionalParams)
  }
}
